import { isAfterEditDeadline } from '#/lib/isAfterEditDeadline';
import { isOnRequestReservation } from '#/lib/isOnRequestReservation';
import { RentalsReservationInstance } from '@jucy-nakuru/common/services/JucyRentalsApi/RentalsReservation';
import ReservationStatusType from '@jucy/rentals-common/data/ReservationStatusType';

const notAllowedStatus = [
    ReservationStatusType.cancelled,
    ReservationStatusType.maintenance,
    ReservationStatusType.returned,
    ReservationStatusType.onRequest,
];

export const isReservationEditable = (reservation?: RentalsReservationInstance) => {
    if (!reservation) {
        return false;
    }

    if (!reservation.isWebAccount) {
        return false;
    }

    if (notAllowedStatus.includes(reservation.status)) {
        return false;
    }

    const pickUpDate = reservation.pickUpDate;
    if (!pickUpDate) {
        return false;
    }

    return isAfterEditDeadline({ pickUpDate }) && !isOnRequestReservation(reservation);
};
